import { render, staticRenderFns } from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=template&id=a2a1e55a&scoped=true"
import script from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=script&lang=js"
export * from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=script&lang=js"
import style0 from "./SelectedStudyEnvironmentTimeAllocation.vue?vue&type=style&index=0&id=a2a1e55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a1e55a",
  null
  
)

export default component.exports